import ServerInstance from "./server.api";

class PropertyEndpoint extends ServerInstance {
    async getProperties() {
        try {
            const response = await this.get("property");
            return response.data;
        } catch (error) {
            throw error;
        }
    }
    async dashboardProperty() {
        try {
            const response = await this.get("property/dashboard");
            return response.data;
        } catch (error) {
            throw error;
        }
    }

    async getPropertyById(id, type) {
        try {
            const response = await this.get(`property/${id}?type=${type}`);
            return response.data;
        } catch (error) {
            throw error;
        }
    }

    async deleteOfficer(id, propertyId) {
        try {
            const response = await this.delete(`property/officer?officer_id=${id}&property_id=${propertyId}`);
            return response.data;
        } catch (error) {
            throw error;
        }
    }

    async updateProperty(id, { type, property_data, detail_data }) {
        try {
            const response = await this.patch(`property/${id}`, {
                type,
                property_data,
                detail_data,
            });
            return response.data;
        } catch (error) {
            throw error;
        }
    }


    async getOfficer(id, type) {
        try {
            const response = await this.get(`property/officer/${id}?type=${type}`);
            return response.data;
        } catch (error) {
            console.error(error);

            throw error;
        }
    }

    async addOfficer(data) {
        try {
            const response = await this.post(`property/officer/`, data);
            return response.data;
        } catch (error) {
            throw error;
        }
    }

    async createProperty(formData) {
        try {
            const response = await this.post("property", formData);
            return response.data;
        } catch (error) {
            throw error;
        }
    }
}

export default PropertyEndpoint;
